
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ACTIONS } from '../../constants/actions';
import { GETTERS } from '../../constants/getters';
import { APP_VUEX_MODULES } from '../../constants/vuex-modules';

interface CountDownTimerComponentData {
  interval: any;
  remainingTime: number;
}

export default Vue.extend({
  name: 'CountDownTimer',
  data(): CountDownTimerComponentData {
    return {
      interval: null,
      remainingTime: 0
    };
  },
  created(): void {
    this.startInterval();
  },
  destroyed(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  computed: {
    ...mapGetters(APP_VUEX_MODULES.ui, {
      nextAvailableTimeToSendOtp: GETTERS.ui.nextAvailableTimeToSendOtp
    })
  },
  methods: {
    startInterval(): void {
      this.interval = setInterval(() => {
        const now = new Date().getTime() / 1000;
        const remainingSecondsToNextOtp = this.nextAvailableTimeToSendOtp - now;
        if (remainingSecondsToNextOtp > 0) {
          this.remainingTime = remainingSecondsToNextOtp;
        } else {
          clearInterval(this.interval as NodeJS.Timeout);
          const { dispatch } = this.$store;
          dispatch(ACTIONS.ui.setNextAvailableTimeToSendOtpAsNull);
        }
      }, 1000);
    },
    resendOtp(): void {
      this.$emit('resendOtp');
    }
  }
});
